import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationService } from 'src/app/_services/navigation.service';
import { ToastrService } from 'ngx-toastr';
import { WebsiteService } from 'src/app/_services/website.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { RecaptchaService } from 'src/app/_services/recaptcha.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-documark-form',
  templateUrl: './documark-form.component.html',
  styleUrls: ['./documark-form.component.scss']
})
export class DocumarkFormComponent implements OnInit {

  @Input() subtitle: string | null = null;
  @Input() emailLabel: string = 'University Email*';

  contactForm: FormGroup;
  formSection = true;
  thankSection = false;
  country: string;
  isSubmitting = false;
  tabsData: any;

  currentStep = 1;
  totalSteps = 3;
  direction: 'forward' | 'backward' = 'forward';

  // Controls that must be valid before leaving each step
  private stepControls: { [step: number]: string[] } = {
    1: ['userType'],
    2: ['firstName', 'lastName', 'contactFormEmail', 'DesignationTypes', 'organization'],
    3: ['message', 'timeline']
  };

  constructor(
    private toastr: ToastrService,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    @Inject(PLATFORM_ID) private platformId: Object,
    public loadScript: LoadScriptService,
    private router: Router,
    public navigationService: NavigationService,
    private recaptcha: RecaptchaService,
  ) {
    this.contactForm = fb.group({
      // Step 1
      'userType': ['', Validators.required],
      // Step 2
      'firstName': ['', Validators.required],
      'lastName': ['', Validators.required],
      'contactFormEmail': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])],
      'DesignationTypes': ['', Validators.required],
      'organization': ['', Validators.required],
      // Step 3
      'message': ['', Validators.required],
      'timeline': ['', Validators.required],
      // Honeypot
      'website': ['']
    });
  }

  ngOnInit(): void {
  }

  get stepCounter(): string {
    return '0' + this.currentStep;
  }

  isStepValid(step: number): boolean {
    return this.stepControls[step].every(name => this.contactForm.get(name).valid);
  }

  isInvalid(name: string): boolean {
    const control = this.contactForm.get(name);
    return !!control && control.invalid && control.touched;
  }

  nextStep() {
    if (!this.isStepValid(this.currentStep)) {
      this.stepControls[this.currentStep].forEach(name => this.contactForm.get(name).markAsTouched({ onlySelf: true }));
      return;
    }
    if (this.currentStep < this.totalSteps) {
      this.direction = 'forward';
      this.currentStep++;
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.direction = 'backward';
      this.currentStep--;
    }
  }

  // submitForm() {

  //   if (this.contactForm.value.website) {
  //     console.warn('Spam detected');
  //     return;
  //   }
  
  //   if (this.contactForm.invalid) {
  //     this.validateAllFormFields(this.contactForm);
  
  //     // Jump back to the first step that has an error
  //     for (let step = 1; step <= this.totalSteps; step++) {
  //       if (!this.isStepValid(step)) {
  //         this.direction = step < this.currentStep ? 'backward' : 'forward';
  //         this.currentStep = step;
  //         break;
  //       }
  //     }
  
  //     return;
  //   }
  
  //   this.isSubmitting = true;
  
  //   if (!localStorage.getItem("country-trinka")) {
  //     this.loadGeoAPIScript();
  //   }
  
  //   this.country = localStorage.getItem("country-trinka") || "en";
  
  //   const v = this.contactForm.value;
  
  //   const name = `${v.firstName} ${v.lastName}`.trim();
  //   const designation = v.DesignationTypes;
  //   const email = v.contactFormEmail;
  //   const source = this.router.url || 'N/A';
  
  //   const query = `
  //     Name: ${name}
  //     Designation: ${designation}
  //     User Type: ${v.userType}
  //     Organization: ${v.organization}
  //     Message: ${v.message}
  //     Timeline: ${v.timeline}
  //   `;
  
  //   console.log('Submitting form:', {
  //     email,
  //     query,
  //     source
  //   });
  
  //   this.networkCall.postContactUs1(email, query, source)
  //     .subscribe({
  //       next: (response) => {
  
  //         console.log('API Success:', response);
  
  //         this.toastr.success("Thanks! We will contact you shortly.");
  
  //         this.formSection = false;
  //         this.thankSection = true;
  
  //         this.contactForm.reset();
  //       },
  
  //       error: (error) => {
  
  //         console.error('API Error:', error);
  
  //         this.toastr.warning("Something went wrong!");
  //       }
  //     })
  //     .add(() => {
  //       this.isSubmitting = false;
  //     });
  // }

  sendContactUsForm() {
    if (this.contactForm.value.website) {
      console.warn('Spam detected');
      return;
    }
  
    if (this.contactForm.invalid) {
      this.validateAllFormFields(this.contactForm);
  
      // Jump back to the first step that has an error
      for (let step = 1; step <= this.totalSteps; step++) {
        if (!this.isStepValid(step)) {
          this.direction = step < this.currentStep ? 'backward' : 'forward';
          this.currentStep = step;
          break;
        }
      }
      return;
    }
  
    this.isSubmitting = true;
  
    if (!localStorage.getItem('country-trinka')) {
      this.loadGeoAPIScript();
    }
    this.country = localStorage.getItem('country-trinka') || 'IN';
  
    this.recaptcha.getToken('contact_form').then(token => {
  
      const v = this.contactForm.value;
  
      const name = `${v.firstName} ${v.lastName}`.trim();
      const designation = v.DesignationTypes || 'N/A';
      const email = v.contactFormEmail;
      const source = this.router.url || 'N/A';
  
      // Human-readable requirement/details
      const comments = `${v.message}
  User Type: ${v.userType}
  Organization - ${v.organization}
  Timeline - ${v.timeline}`;
  
      // IMPORTANT: Keep the || format expected by the backend
      const query =
      `${name}` +
      `||${designation}` +
      `||${v.organization}` +
      `||${v.userType}` +
      `||${comments}` +
      `||${v.timeline}`;

  
      this.networkCall.postContactUs(email, query, source).subscribe({
        next: () => {
          this.toastr.success('Thanks! We will contact you shortly.');
          this.formSection = false;
          this.thankSection = true;
          this.contactForm.reset();
        },
        error: () => {
          this.toastr.warning('Something went wrong!');
        }
      }).add(() => {
        this.isSubmitting = false;
      });
  
    }).catch(err => {
      console.error('reCAPTCHA error:', err);
      this.isSubmitting = false;
    });
  }

  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
      var scriptName = "geoIP"
      this.loadScript.loadScript(scriptName, '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
        .then(() => {
          console.log(`${scriptName} loaded successfully`);
          var onSuccess = function (location) {
            localStorage.setItem("country-trinka", location['country']['iso_code'])
          };

          var onError = function (error) {
            localStorage.setItem("country-trinka", "IN")
          };
          try {
            //@ts-ignore
            geoip2.city(onSuccess, onError);
          } catch (error) {
            console.log(error)
          }
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

}
